import images from "./images";

const menu = {
    bread: [
        {
            id: 1,
            name: "Bagel",
            price: 20,
            description: "Classic chewy bread ring, perfect for breakfast or snacks.",
            image: images.bread1,
        },
        {
            id: 2,
            name: "Baguette",
            price: 20,
            description: "Traditional French long bread with a crispy crust and soft inside.",
            image: images.bread2,
        },
        {
            id: 3,
            name: "Banana Bread",
            price: 20,
            description: "Moist, sweet bread made with ripe bananas, ideal for tea-time.",
            image: images.bread3,
        },
        {
            id: 4,
            name: "Cheese Bread",
            price: 20,
            description: "Savory bread loaded with melted cheese for a rich flavor.",
            image: images.bread4,
        },
        {
            id: 5,
            name: "Brioche",
            price: 20,
            description: "Soft, buttery bread with a golden crust, perfect for sandwiches.",
            image: images.bread5,
        },
        {
            id: 6,
            name: "Rye Bread",
            price: 20,
            description: "Dense bread made with rye flour, offering a distinct hearty taste.",
            image: images.bread6,
        },
        {
            id: 7,
            name: "Bread roll",
            price: 20,
            description: "Soft and fluffy individual bread rolls, ideal for sides or sliders.",
            image: images.bread7,
        },
        {
            id: 8,
            name: "Soda Bread",
            price: 20,
            description: "Irish-style quick bread with a tender crumb and rustic taste.",
            image: images.bread8,
        }
    ],
    cake: [
        {
            id: 1,
            name: "Chocolate Cake",
            price: 20,
            description: "Rich and moist chocolate cake topped with creamy chocolate frosting.",
            image: images.cake1,
        },
        {
            id: 2,
            name: "Carrot Cake",
            price: 20,
            description: "Moist carrot cake loaded with nuts and layered with cream cheese frosting.",
            image: images.cake2,
        },
        {
            id: 3,
            name: "Red Velvet Cake",
            price: 20,
            description: "Classic red velvet cake with a light cocoa flavor and cream cheese frosting.",
            image: images.cake3,
        },
        {
            id: 4,
            name: "Strawberry Cake",
            price: 20,
            description: "Soft and fruity cake layered with fresh strawberry filling and frosting.",
            image: images.cake4,
        },
        {
            id: 5,
            name: "Chiffon Cake",
            price: 20,
            description: "Light and airy sponge cake, perfect for any celebration.",
            image: images.cake5,
        },
        {
            id: 6,
            name: "Cheese Cake",
            price: 20,
            description: "Creamy and smooth cheesecake with a buttery biscuit base.",
            image: images.cake6,
        },
        {
            id: 7,
            name: "Fruit Cake",
            price: 20,
            description: "Classic fruit cake loaded with dried fruits and nuts, rich in flavor.",
            image: images.cake7,
        },
        {
            id: 8,
            name: "Cupcake",
            price: 20,
            description: "Soft and fluffy individual cakes topped with creamy frosting and sprinkles.",
            image: images.cake8,
        }
    ],
    pastry: [
        {
            id: 1,
            name: "Croissant",
            price: 20,
            description: "Flaky, buttery French pastry, perfect for breakfast or snacks.",
            image: images.pastry1,
        },
        {
            id: 2,
            name: "Cherry Pie",
            price: 20,
            description: "Sweet and tangy cherry filling encased in a golden pie crust.",
            image: images.pastry2,
        },
        {
            id: 3,
            name: "Macaron",
            price: 20,
            description: "Delicate almond meringue sandwich cookies with creamy filling.",
            image: images.pastry3,
        },
        {
            id: 4,
            name: "Pecan Pie",
            price: 20,
            description: "Rich, buttery pie filled with toasted pecans and sweet syrup.",
            image: images.pastry4,
        },
        {
            id: 5,
            name: "Pretzels",
            price: 20,
            description: "Soft, twisted bread sprinkled with sea salt, perfect as a snack.",
            image: images.pastry5,
        },
        {
            id: 6,
            name: "Baklava",
            price: 20,
            description: "Layered pastry with nuts and honey syrup, rich in Mediterranean flavors.",
            image: images.pastry6,
        },
        {
            id: 7,
            name: "Eclair",
            price: 20,
            description: "Light choux pastry filled with cream and topped with chocolate glaze.",
            image: images.pastry7,
        },
        {
            id: 8,
            name: "Puff Pastry",
            price: 20,
            description: "Crispy, flaky pastry layers that melt in your mouth, great for sweet or savory fillings.",
            image: images.pastry8,
        }
    ],
    beverages: [
        {
            id: 1,
            name: "Americano",
            price: 20,
            description: "Smooth espresso diluted with hot water for a rich, bold flavor.",
            image: images.beverage1,
        },
        {
            id: 2,
            name: "Espresso",
            price: 20,
            description: "Strong and concentrated coffee shot, perfect for a quick caffeine boost.",
            image: images.beverage2,
        },
        {
            id: 3,
            name: "Cappucino",
            price: 20,
            description: "Classic espresso drink with steamed milk and a thick layer of foam.",
            image: images.beverage3,
        },
        {
            id: 4,
            name: "Latte",
            price: 20,
            description: "Creamy espresso-based drink with steamed milk and a light foam topping.",
            image: images.beverage4,
        },
        {
            id: 5,
            name: "Black Coffee",
            price: 20,
            description: "Simple and pure brewed coffee without milk or sugar.",
            image: images.beverage5,
        },
        {
            id: 6,
            name: "Mocha",
            price: 20,
            description: "Espresso blended with rich chocolate syrup and steamed milk.",
            image: images.beverage6,
        },
        {
            id: 7,
            name: "Café au Lait",
            price: 20,
            description: "Traditional French-style coffee made with brewed coffee and steamed milk.",
            image: images.beverage7,
        },
        {
            id: 8,
            name: "Macchiato",
            price: 20,
            description: "Espresso marked with a small amount of frothy milk for a bold taste.",
            image: images.beverage8,
        }
    ],

};

export default menu;